import React from 'react';
import './style.scss';
import nonResult from '../../../assets/img/mixer/empty_mixer.png';
import BaseButton from "../../form/Button";
import { useHistory } from 'react-router-dom';

const PreferencesNoResults = () => {
    const history = useHistory();
    return (
        <div className="preferences-non-results">
            <div className="preferences-non-results__container">
                <img
                    className="preferences-non-results__image"
                    src={nonResult}
                    alt="Миксер"
                />
                <div className="preferences-non-results__title">
                    Упс, мы не смогли
                    ничего найти
                    <span role="img" aria-label="oops">😥</span>
                </div>
                <div>
                    <BaseButton
                        isGreenButton
                        isFullWidth
                        sizeBorderRadius={30}
                        sizePadding="9px 0"
                        onClick={() => history.push("/mixer")}>
                        <span className="preferences-non-results__button-text">
                            Попробовать снова
                        </span>
                    </BaseButton>
                </div>
             </div>
        </div>
    )
};

export default PreferencesNoResults;


